import React from 'react'
import * as R from 'remeda'

import { type RoleName } from '~/gql/graphql'
import { useCommonQuery } from '~/hooks/useCommonQuery'
import { exists } from '~/utils'

import { useIsCoreMember } from './useIsCoreMember'

const allowedRoleNames: RoleName[] = ['MFORCE', 'MFORCE_WITH_SETTING']

export const useIsMforceUser = (brandAccountId?: string) => {
  const { data } = useCommonQuery()
  const isCoreMember = useIsCoreMember()

  return React.useMemo(() => {
    if (!exists(brandAccountId)) {
      return false
    }

    if (isCoreMember) {
      return true
    }

    const roleName = data?.brandAccountRoles?.find(
      (role) => role.brandAccount.id === brandAccountId,
    )?.role?.name

    return exists(roleName) && R.isIncludedIn(roleName, allowedRoleNames)
  }, [brandAccountId, data?.brandAccountRoles, isCoreMember])
}
